import React from 'react';

import { Button } from 'modules/cxi/components/button';

import { useStartupCXI } from '../../useStartupCXI';
import { Container } from '../container';
import * as Styled from './StyledMentoringRejected';

export const MentoringRejected = () => {
    const { t, modal, setModal } = useStartupCXI();
    const { match } = modal;

    return (
        <Styled.MentoringRejected as={Container.Slim}>
            <Container.Head image={match.evaluator.photoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.MentoringRejected.title')}</Styled.Title>
                <Styled.Descr>{t('modal.MentoringRejected.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.MentoringRejected>
    );
};
